var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrophy = function SvgTrophy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70586 4.59949H34.2943C35.7887 4.59949 37.0001 5.80757 37.0001 7.30535C37.0001 17.2407 28.9434 25.2996 19.0001 25.2996C9.05891 25.2996 1 17.2429 1 7.2995C1 5.81094 2.20808 4.59949 3.70586 4.59949Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6002 25.3008H15.4002V31.8002C13.3201 32.4056 11.8 34.3261 11.8 36.6016V37.0016H26.2001V36.6016C26.2001 34.3262 24.6802 32.4058 22.6002 31.8003V25.3008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4002 25.3008V24.3008C14.8479 24.3008 14.4002 24.7485 14.4002 25.3008H15.4002ZM22.6002 25.3008H23.6002C23.6002 24.7485 23.1525 24.3008 22.6002 24.3008V25.3008ZM15.4002 31.8002L15.6796 32.7604C16.1066 32.6361 16.4002 32.2449 16.4002 31.8002H15.4002ZM11.8 37.0016H10.8C10.8 37.5539 11.2478 38.0016 11.8 38.0016V37.0016ZM26.2001 37.0016V38.0016C26.7524 38.0016 27.2001 37.5539 27.2001 37.0016H26.2001ZM22.6002 31.8003H21.6002C21.6002 32.2449 21.8938 32.6361 22.3207 32.7604L22.6002 31.8003ZM15.4002 26.3008H22.6002V24.3008H15.4002V26.3008ZM16.4002 31.8002V25.3008H14.4002V31.8002H16.4002ZM12.8 36.6016C12.8 34.7827 14.0149 33.2449 15.6796 32.7604L15.1207 30.84C12.6252 31.5664 10.8 33.8695 10.8 36.6016H12.8ZM12.8 37.0016V36.6016H10.8V37.0016H12.8ZM26.2001 36.0016H11.8V38.0016H26.2001V36.0016ZM25.2001 36.6016V37.0016H27.2001V36.6016H25.2001ZM22.3207 32.7604C23.9853 33.245 25.2001 34.7827 25.2001 36.6016H27.2001C27.2001 33.8696 25.375 31.5665 22.8797 30.8401L22.3207 32.7604ZM21.6002 25.3008V31.8003H23.6002V25.3008H21.6002Z",
    fill: "#80ABFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19995 2.99988C8.19995 1.89531 9.09538 0.999878 10.2 0.999878H27.8C28.9046 0.999878 29.8 1.89531 29.8 2.99988V18C29.8 23.5228 25.3229 28 19.8 28H18.1999C12.6771 28 8.19995 23.5228 8.19995 18V2.99988Z",
    fill: "white",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0001 16.6488L16.3635 17.9794C15.7786 18.2746 15.3953 18.0055 15.5067 17.3819L16.0103 14.5635L13.8772 12.5676C13.404 12.1248 13.5522 11.6917 14.2045 11.6007L17.1523 11.1895L18.4706 8.62534C18.7631 8.05652 19.2379 8.05792 19.5297 8.62534L20.848 11.1895L23.7958 11.6007C24.4497 11.6919 24.5951 12.1259 24.1231 12.5676L21.99 14.5635L22.4935 17.3819C22.6052 18.0071 22.2202 18.2739 21.6368 17.9794L19.0001 16.6488Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrophy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trophy.5149ae6d.svg";
export { ForwardRef as ReactComponent };